//Common
export const HIGHLIGHT_COLOR = '#0051ff'
export const RED_COLOR = '#e91545'
export const GREEN_COLOR = '#00f0ff'
export const BLACK_COLOR = '#000d28'
export const WHITE_COLOR = '#ffffff'
export const GREY_COLOR = '#d1d1d1'

//Redepositbonus page
export const btnStyleConfig = {
  BTN_ACTIVE: {
    bgColor: '#0051ff',
    border: 'solid 2px #0051ff',
    color: '#fff',
    borderRadius: '34px',
    padding: '10px 53px',
    fontSize: '21px',
    lineHeight: 'normal',
    fontWeight: 500,
  },
  BTN_DEFAULT: {
    bgColor: '#fff',
    border: 'solid 2px #0051ff',
    color: '#0051ff',
    borderRadius: '34px',
    padding: '10px 53px',
    fontSize: '21px',
    lineHeight: 'normal',
    fontWeight: 500,
  },
}
